import { firestore } from 'firebase/app';
import { SparkMapper, FirestoreSpark, SparkelloImage, SparkelloImageMapper } from 'sparkello-core';
import { WebSpark } from '@/web/model';
import DocumentSnapshot = firestore.DocumentSnapshot;
import FieldValue = firestore.FieldValue;

export class WebSparkMapper implements SparkMapper<DocumentSnapshot, FieldValue> {
  public mapToLocalSpark(doc: DocumentSnapshot): WebSpark {
    const sparkProps = {
      id: doc.id,
      displayName: doc.data()?.displayName,
      image: SparkelloImageMapper.mapToSparkelloImage(doc.data()?.image, doc.data()?.imageUri),
      description: doc.data()?.description,
      visibility: doc.data()?.visibility,
      dateCreated: doc.data()?.dateCreated?.toDate(),
      lastUpdated: doc.data()?.lastUpdated?.toDate(),
    };

    return new WebSpark(sparkProps);
  }

  public mapSparkCacheToLocalSpark(id: string, doc: Record<string, any>): WebSpark {
    const sparkProps = {
      id: id,
      displayName: doc?.displayName,
      image: SparkelloImageMapper.mapToSparkelloImage(doc?.image, doc?.imageUri),
      description: doc?.description,
      visibility: doc?.visibility,
      dateCreated: doc?.dateCreated?._seconds ? new Date(doc?.dateCreated?._seconds*1000) : undefined,
      lastUpdated: doc?.lastUpdated?._seconds ? new Date(doc?.lastUpdated?._seconds*1000) : undefined,
    };

    return new WebSpark(sparkProps);
  }

  public mapToFirestoreSpark(spark: WebSpark): FirestoreSpark<FieldValue> {
    const firestoreSpark: FirestoreSpark<FieldValue> = {
      displayName: spark.displayName,
      description: spark?.description || '',
      visibility: spark?.visibility || 'private',
      image: SparkelloImageMapper.mapToFirestoreImage(spark.image),
      dateCreated: spark?.dateCreated ? spark?.dateCreated : firestore.FieldValue.serverTimestamp(),
      lastUpdated: firestore.FieldValue.serverTimestamp(),
    };

    return firestoreSpark;
  }
}
